import Service from './Service';
import { format, isAfter, isEqual, parse } from 'date-fns';

/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class ProfissionalService extends Service {
  async consultarNomesTodosProfissionais () {
    let nomes = await this.getProfissionalApi().consultarNomesTodosProfissionais();
    return nomes || [];
  }

  async consultarEspecialidades () {
    let especialidades = await this.getProfissionalApi().consultarEspecialidades();
    return especialidades || [];
  }

  async consultarEspecialidadesPermitidas (codPrestador) {
    let especialidades = await this.getProfissionalApi().consultarEspecialidadesPermitidas(codPrestador);
    return especialidades || [];
  }

  async consultarCROs () {
    let CROs = await this.getProfissionalApi().consultarCROs();
    return CROs || [];
  }

  async consultarProfissionais (filter) {
    let profissionais = [];
    let arrayPrestador = [];
    const brancoAcoes = '';
    let result = await this.getProfissionalApi().consultarProfissionais(filter);
    result.map(res => {
      const { seqProfissional, numRegistro, codConselho, siglaConselho, nome, profissionalPrestador } = res;
      for (var i = 0; i < profissionalPrestador.length; i++) {
        if (profissionalPrestador[i].nomePrestador != null) {
          if (profissionalPrestador[i].dtaFim === null) {
            arrayPrestador.push(' * ' + profissionalPrestador[i].nomePrestador + ' desde ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY'));
          } else {
            arrayPrestador.push(' * ' + profissionalPrestador[i].nomePrestador + ' de ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(profissionalPrestador[i].dtaFim), 'DD/MM/YYYY'));
          }
          var especialidades = profissionalPrestador[i].desEspecialidades.split(',');
          for (var j = 0; j < especialidades.length; j++) {
            arrayPrestador.push(especialidades[j]);
          }
          if (profissionalPrestador[i].dtaFim === null) {
            if (i + 1 !== profissionalPrestador.length) {
              arrayPrestador.push('-'.repeat((' * ' + profissionalPrestador[i].nomePrestador + ' desde ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY')).length + 60));
            }
          } else {
            if (i + 1 !== profissionalPrestador.length) {
              arrayPrestador.push('-'.repeat((' * ' + profissionalPrestador[i].nomePrestador + ' de ' + format(new Date(profissionalPrestador[i].dtaInicio), 'DD/MM/YYYY') + ' até ' + format(new Date(profissionalPrestador[i].dtaFim), 'DD/MM/YYYY')).length + 60));
            }
          }
        } else {
          arrayPrestador.push('Profissional sem prestador vinculado');
        }
      }
      profissionais.push(Object.values({ seqProfissional, nome, numRegistro, codConselho, siglaConselho, arrayPrestador, brancoAcoes, profissionalPrestador }));
      arrayPrestador = [];
    });
    return profissionais || [];
  }
  async incluirProfissional (profissional) {
    let result = await this.getProfissionalApi().incluirProfissional(profissional);
    return result;
  }
  async excluirProfissional (numProfissional) {
    let result = await this.getProfissionalApi().excluirProfissional(numProfissional);
    return result;
  }
  async alterarProfissional (profissional) {
    let result = await this.getProfissionalApi().alterarProfissional(profissional);
    return result;
  }
  validarDataInicio (data, dataFim) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));
    dataFim = dataFim === null ? dataNula : parse(parse(dataFim).setHours(0, 0, 0, 0));

    if (isEqual(data, dataNula) || data === undefined || data.toString() === 'Invalid Date') {
      return 'A data não pode ser nula.';
    }
    if (!isEqual(data, dataNula) && !isEqual(dataFim, dataNula) && isAfter(data, dataFim)) {
      return 'A data não pode ser maior que a data fim.';
    }
    return '';
  }
  validarDataFim (data, dataInicio) {
    var dataNula = parse(new Date(null).setHours(0, 0, 0, 0));
    data = data === null || data === '' ? dataNula : parse(parse(data).setHours(0, 0, 0, 0));

    if (!isEqual(data, dataNula) && isAfter(dataInicio, data)) {
      return 'A data não pode ser menor que a data de início.';
    }
    return '';
  }
  async validarProfissional (profissional, indInclusao) {
    const result = await this.getProfissionalApi().validarProfissional(profissional, indInclusao);
    return result;
  }
}
export default ProfissionalService;
